export const contactTemplate = [
  'contactid',
  'fullname',
  'mobilephone',
  'telephone1',
  'telephone2',
  'telephone3',
  'emailaddress1',
  'emailaddress2',
  'emailaddress3',
];

export const accountTemplate = [
  'accountid',
  'name',
  'telephone1',
  'telephone2',
  'telephone3',
  'emailaddress1',
  'emailaddress2',
  'emailaddress3',
];

export const leadTemplate = [
  'leadid',
  'fullname',
  'telephone1',
  'telephone2',
  'telephone3',
  'emailaddress1',
  'emailaddress2',
  'emailaddress3',
];

export const templateMap = {
  account: accountTemplate,
  contact: contactTemplate,
  lead: leadTemplate,
};
